import { WatchQueryFetchPolicy } from '@apollo/client'
import { useStorePartsQuery } from '../graphql'

export default function useStorePartsSearch( storeId?: number, search = '', debounceKey = '' ) {
	return useStorePartsQuery( {
		context: { debounceKey },
		fetchPolicy: 'no-cache' as WatchQueryFetchPolicy,
		variables: {
			search,
			...( storeId ? { storeIds: [ storeId ] } : {} ),
			excludeEmpty: true,
		},
		skip: !storeId
	} )
}
